import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        const ghostUserId = localStorage.getItem('ghostUserId');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else if (ghostUserId && config.url && !config.url.includes('/auth/')) {
            config.headers['X-Ghost-User-Id'] = ghostUserId;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default apiClient;